import React from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import moment from 'moment';
import { Link } from 'react-router-dom';
import MaterialIcon from 'material-icons-react';
// Components
import TitleBar from '../components/TitleBar';

const query = require('array-query');

export class Activity extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      mode: 1,
    };
  }

  UNSAFE_componentWillMount() {}

  componentDidMount() {
    document.title = 'Activity';
  }

  getTotalEvents(events) {
    let count = events.length;
    return (
      <div>
        <span className="statcat">Total Events</span>
        <span className="right stat">{count}</span>
      </div>
    );
  }

  getTotalAwards(awards) {
    let count = awards.length;
    return (
      <div>
        <span className="statcat">Rewards Earned</span>
        <span className="right stat">{count}</span>
      </div>
    );
  }

  getEventsCreated(events, userId) {
    let eventsArray = [];
    events.forEach((event) => {
      if (event.creationDetails.plannerId === userId) {
        eventsArray.push(event);
      }
    });

    let count = eventsArray.length;
    return (
      <div>
        <span className="statcat">Events Created</span>
        <span className="right stat">{count}</span>
      </div>
    );
  }

  getTab(tabMode, tabLable, mode) {
    if (tabMode === mode) {
      return (
        <div className="text-center borderRight actionButtonActive">
          {tabLable}
        </div>
      );
    } else {
      return (
        <a
          onClick={() => {
            this.setMode(tabMode);
          }}
        >
          <div className="text-center borderRight actionButton">
            {tabLable}
          </div>
        </a>
      );
    }
  }

  setMode(mode) {
    this.setState({
      mode,
    });
  }

  getContent(mode, sortedActivites) {
    if (mode === 2) {
      return (
        <div className="pushfifty text-center">
          <b>Coming Soon!</b>
        </div>
      );
    } else if (mode === 1) {
      return (
        <div className="pushforty container">
          <Row className=" no-margin no-padding">
            <div className="fullwidth">
              <ul className="no-padding">
                {sortedActivites.map((edit, index) => (
                  <div>{this.listActivity(edit)}</div>
                ))}
              </ul>
            </div>
          </Row>
        </div>
      );
    }
  }

  getEventName(edit) {
    // return getEventName;
  }

  sortActivites(events) {
    let notificationsArray = [];

    events.forEach((event) => {
      let notice = {
        message: '',
        date: '',
        timestamp: '',
        eventId: '',
        eventTitle: '',
        icon: '',
      };
      let message = '';

      let reverseArray = [...event.editHistory].reverse();

      if (event.status === 0) {
        if (reverseArray[0].eventType === 2) {
          if (this.props.profile.userId !== reverseArray[0].userId) {
            let name = event.users[
              reverseArray[0].userId
            ].profile.fullName.replace(/ .*/, '');
            message = name + ' Approved your event together!';

            notice.message = message;
            notice.date = this.getDate(
              reverseArray[0].editDate.seconds,
            );
            notice.eventId = event.eventId;
            notice.timestamp = reverseArray[0].editDate.seconds;
            notice.eventTitle = event.title;
            // notice.icon = 'thumb_up_alt_outlined_icon';
            notice.icon = 'done_outline_outlined';
            notice.iconColor = 'green';
            notificationsArray.push(notice);
          }
        }
      } else if (event.status === 2) {
        if (reverseArray[0].eventType === 1) {
          if (this.props.profile.userId !== reverseArray[0].userId) {
            let name = event.users[
              reverseArray[0].userId
            ].profile.fullName.replace(/ .*/, '');
            message = name + " edited your event. It's your turn.";

            notice.message = message;
            notice.date = this.getDate(
              reverseArray[0].editDate.seconds,
            );
            notice.eventId = event.eventId;
            notice.eventTitle = event.title;
            notice.icon = 'notification_important_outlined';
            notice.iconColor = 'rgb(242, 29, 89)';
            notificationsArray.push(notice);
          }
        }
      } else if (reverseArray[0].eventType === 3) {
        if (this.props.profile.userId !== reverseArray[0].userId) {
          let name = event.users[
            reverseArray[0].userId
          ].profile.fullName.replace(/ .*/, '');

          if (
            event.creationDetails.plannerId ===
            this.props.profile.userId
          ) {
            message = name + ' Rejected your invitation.';
          } else {
            message = name + ' Rejected your changes to the event.';
          }

          notice.message = message;
          notice.date = this.getDate(
            reverseArray[0].editDate.seconds,
          );
          notice.eventId = event.eventId;
          notice.eventTitle = event.title;
          notice.icon = 'do_disturb';
          notice.iconColor = 'grey';
          notificationsArray.push(notice);
        }
      }
    });

    let sortedNotices = this.sortByDate(notificationsArray, 'date');

    return sortedNotices;
  }

  sortByDate(array, dateField, order = 'desc') {
    return array.sort((a, b) => {
      const dateA = moment(a[dateField]);
      const dateB = moment(b[dateField]);

      if (order === 'asc') {
        return dateA.valueOf() - dateB.valueOf();
      } else if (order === 'desc') {
        return dateB.valueOf() - dateA.valueOf();
      }
    });
  }

  getDate(timestamp) {
    let myDate = new Date(timestamp * 1000);
    let dayTextFinal = moment(myDate).format('MM/DD/YYYY, h:mm:ss a');
    return dayTextFinal;
  }

  // {this.getEventName(edit)}

  // listActivity(edit) {
  //   if (edit.eventType === 1) {
  //     return (
  //       <li className="adminlistitem">
  //         <span>
  //           {edit.fullName} made an edit to <b>{edit.eventTitle}</b>
  //           {edit.eventId}
  //         </span>
  //       </li>
  //     );
  //   }
  // }

  listActivity(edit) {
    return (
      <li
        className="adminlistitem"
        style={{ borderBottom: '1px solid grey' }}
      >
        <Link
          to={{
            pathname: '/event/' + edit.eventId,
            state: {
              backpath: '/activity',
            },
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                width: '45px',
              }}
            >
              <MaterialIcon
                icon={edit.icon}
                size={30}
                color={edit.iconColor}
              />
            </div>
            <div
              style={{
                display: 'block',
                float: 'left',
                width: '90%',
              }}
            >
              <span
                style={{
                  color: 'black',
                  fontWeight: '600',
                }}
              >
                {edit.eventTitle}
              </span>
              <span
                style={{
                  color: 'black',
                  display: 'block',
                  clear: 'both',
                }}
              >
                {edit.message}
              </span>
              <span
                style={{
                  display: 'block',
                  clear: 'both',
                  color: 'grey',
                  fontSize: '12px',
                }}
              >
                {edit.date}
              </span>
            </div>
            <div
              style={{
                display: 'block',
                float: 'right',
              }}
            >
              <MaterialIcon
                icon="arrow_right"
                size={30}
                color="rgb(242, 29, 89)"
              />
            </div>
          </div>
        </Link>
      </li>
    );
  }

  getTitleBar() {
    return (
      <div id="headersTop">
        <div className="backbar">
          <Row className="no-margin">
            <Col lg={2} md={2} sm={2} xs={2} className="no-padding">
              <Link
                to={{
                  pathname: '/home',
                }}
                className="left"
              >
                <MaterialIcon icon="close" size={25} color="white" />
              </Link>
            </Col>
            <Col lg={8} md={8} sm={8} xs={8}>
              <center>
                <span className="page-header">Notifications</span>
              </center>
            </Col>

            <Col lg={2} md={2} sm={2} xs={2} className="no-padding">
              {/* <Link
                to={{
                  pathname: '/past-events',
                }}
                className="right"
              >
                <span>
                  Completed{' '}
                  <MaterialIcon
                    icon="close"
                    size={25}
                    color="white"
                  />
                </span>
              </Link> */}
            </Col>
          </Row>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.loading) {
      return null; // or render a loading icon
    }
    let sortedActivites = this.sortActivites(this.props.events);
    return (
      <div id="profile">
        {this.getTitleBar()}
        {/* <div className="adminActionBar">
          <Row>
            <Col lg={6} md={6} sm={6} xs={6} className="no-padding">
              {this.getTab(1, "Your Points", this.state.mode)}
            </Col>
            <Col lg={6} md={6} sm={6} xs={6} className="no-padding">
              {this.getTab(2, "Your Ranking", this.state.mode)}
            </Col>
          </Row>
        </div> */}
        {/* <div className="section actionBarPush"> */}
        <div className="section">
          {this.getContent(this.state.mode, sortedActivites)}
        </div>
        <style
          dangerouslySetInnerHTML={{
            __html:
              '#startBar{background-color: #ef0059;} .adminActionBar {top: 40px !important;} #events{position: relative;}  #headersTop {width: 100% !important;} #headersTopSecondary{width: 100%} #authright {padding-left: 0px !important;}  #mobile-nav { display: none } #authleft {display:none;} #events{position: relative; top: 40px}  #bottomNav{left:0px; width:100%} .maincontent { top: 0px; margin-top: 0px; height: 100%} .footer{display:none} .full-height{height:100%} .maincontent-push { position: relative; height: 100%;}',
          }}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    profile: state.profile.profile,
    events: state.events.events,
    awards: state.userAwards.awards,
  };
}

export default connect(mapStateToProps)(Activity);
